import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, del, get, post } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomerPartNumberModel } from "@tCooneyBrothers/ApiModels";
import { DeleteCpnParameter } from "@tCooneyBrothers/Handlers/DeleteCustomerPartNumber";

const custPartNumberUrl = "api/v2/customerpartnumber";

export async function getCustomerPartNumbers(productId: string) {
    try {
        const cpnCollection = await get<CustomerPartNumberModel[]>(`${custPartNumberUrl}/${productId}`, {})
            .then(response => {
                // eslint-disable-next-line no-console
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return cpnCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addCustomerPartNumber(parameter: CustomerPartNumberModel) {
    // eslint-disable-next-line no-console
    return post<CustomerPartNumberModel>(custPartNumberUrl, parameter);
}

export function deleteCustomerPartNumber(param: DeleteCpnParameter) {
    const delCPN = del(`${custPartNumberUrl}/${param.id}`)
        .then(response => {
            // eslint-disable-next-line no-console
            console.log("inside deleteservice :", response);
            return response;
        })
        .catch(async err => {
            if (isApiError(err) || err.status === 200 || err.status === 404) {
                const cpnCollection = await get<CustomerPartNumberModel[]>(
                    `${custPartNumberUrl}/${param.productId}`,
                    {},
                )
                    .then(response => {
                        // eslint-disable-next-line no-console
                        return response;
                    })
                    .catch(err => {
                        // eslint-disable-next-line no-console
                        console.error("Console error", err);
                    });

                return cpnCollection;
            }
            // eslint-disable-next-line no-console
            console.error("Console error", err);
        });
    return delCPN;
}

export interface GetProductByIdApiV2Parameter extends ApiParameter {
    customerId: string;
    productId: string;
    customerPartNumber: string;
    unitOfMeasure: string;
}

export interface AddCustomerPartNumber extends ApiParameter {
    customerPartNumberParameter: ProductModel;
}
